<template>
  <div id="mobile-app">
    <app-header v-show="!$router.currentRoute.meta.overrideHeader"></app-header>
    <div class="container-fluid p-0 d-flex align-items-stretch">
      <sidebar-nav v-show="!$router.currentRoute.meta.hideSidebar"></sidebar-nav>
      <div
        :class="`main flex-grow-1 ${sidebar == SIDEBAR.EXPANDED ? 'show-sidebar' : ''} ${$smallScreen ? 'mobile' : ''}`"
        @click="clickMain"
      >
        <vams-notifications />
        <div :class="`flex-grow-1 ${$smallScreen ? '' : 'mx-3 pt-3'}`">
          <div v-if="loading" class="text-center py-4">
            <b-spinner></b-spinner>
          </div>
          <router-view v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// components
import AppHeader from '@/mobile/components/layouts/AppHeader';
import SidebarNav from '@/mobile/components/layouts/SidebarNav';
import NotificationsComponent from '@/mobile/components/NotificationsComponent';
// vuex
import { ConfigGetters } from '@/shared/store/config/types';
import { RootGetters, RootMutations } from '@/shared/store/types';
import { UserGetters } from '@/shared/store/user/types';
import { LookupGetters } from '@/shared/store/lookup/types';
import { UserActions } from '@/shared/store/user/types';
import { SIDEBAR } from '@/shared/store/state';
import { mapGetters } from 'vuex';

import Vue from 'vue';

export default {
  name: 'VehicareMobileApp',
  components: {
    'app-header': AppHeader,
    'sidebar-nav': SidebarNav,
    'vams-notifications': NotificationsComponent
  },
  data() {
    return {
      msalInProgress: true,
      SIDEBAR: SIDEBAR
    };
  },
  computed: {
    ...mapGetters([ConfigGetters.GET_CONFIG]),
    ...mapGetters({ isAuthenticated: UserGetters.IS_AUTHENTICATED }),
    loading() {
      return (
        this.msalInProgress ||
        this.$store.getters[LookupGetters.GET_LOADING] ||
        this.$store.getters[UserGetters.GET_LOADING]
      );
    },
    sidebar: {
      get() {
        return this.$store.getters[RootGetters.GET_SIDEBAR];
      },
      set(value) {
        this.$store.commit(RootMutations.SET_SIDEBAR, value);
      }
    },
    environment() {
      const environment = this[ConfigGetters.GET_CONFIG].environment.toUpperCase();
      if (environment.startsWith('PROD')) {
        return '';
      }
      return environment;
    }
  },
  watch: {
    $route: {
      handler(to) {
        document.title = 'VAMS Mobile';
        document.title += to.meta.title ? ' - ' + to.meta.title : '';
      },
      immediate: true
    },
    $smallScreen: {
      handler() {
        if (this.$smallScreen) {
          this.sidebar = SIDEBAR.COLLAPSED;
        } else {
          this.sidebar = SIDEBAR.EXPANDED;
        }
      },
      immediate: true
    }
  },
  created() {
    document.title = 'VAMS Mobile';
    Vue.prototype.$environment = this.environment;
    this.$msal.events.$on('login-success', async account => {
      try {
        await this.$store.dispatch(UserActions.AFTER_LOGIN, account);
      } finally {
        this.msalInProgress = false;
      }
    });
    this.$msal.events.$on('login-error', async () => {
      this.msalInProgress = false;
    });
  },
  methods: {
    clickMain() {
      if (this.$smallScreen) {
        this.sidebar = SIDEBAR.COLLAPSED;
      }
    }
  }
};
</script>
